import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Registration} from "../../../../../models/registration";
import {RoleRegistration} from "../../../../../models/role-registration";
import {RegistrationControllerService} from "../../../../../services/registration-controller/registration-controller.service";
import {RoleRegistrationControllerService} from "../../../../../services/role-controller/role-registration-controller.service";
import {BaseError} from "../../../base-error";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "registrations-role-manage",
  templateUrl: "./registrations-role-manage.component.html",
  providers: [RoleRegistrationControllerService, RegistrationControllerService],
})
export class RegistrationsRoleManageComponent extends TranslatedBaseError implements OnInit {

  @ViewChild("lgModal") public childModal;
  @Output() public refreshRegistrations = new EventEmitter();
  @Input() public registration = new RoleRegistration();
  @Input() public selectedRegistrationsList;
  @Input() public registrationId: any;
  public registrationsList: Registration[];
  public notSelectedRegistrationsList: Registration[];
  public serviceId: string;
  public roleId: string;
  public baseUrl: string;
  public userFilter: any = {name: ""};

  constructor(private roleRegistrationController: RoleRegistrationControllerService,
              private registrationController: RegistrationControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.roleId = params.roleId;
    });
    this.getSystemRegistrations(this.serviceId);

  }

  public initData() {
    this.filterNotSelectedRegistrations();
    this.childModal.config.backdrop = true;
    this.childModal.show();
  }

  public filterNotSelectedRegistrations() {
    if (this.registrationsList && this.selectedRegistrationsList) {
      this.notSelectedRegistrationsList = [];
      this.registrationsList.forEach((item) => {
        let isSelected = false;
        this.selectedRegistrationsList.forEach((item2) => {
          isSelected = (item.id === item2.registrationId) ? true : isSelected;
        });
        if (!isSelected) {
          this.notSelectedRegistrationsList.push(item);
        }
      });
    }
  }

  public getSystemRegistrations(serviceId) {
    this.registrationController.getRegistrationsList(serviceId).subscribe(
      (data) => {
        this.registrationsList = data;
        this.filterNotSelectedRegistrations();
      },
      (error) => this.showErrorMessageWithTitle("Unable to get registrations list", error),
    );

  }

  public createRoleRegistration() {
    this.roleRegistrationController.createRoleRegistration(this.roleId, this.registrationId).subscribe(
      (data) => this.refreshRegistrations.emit(),
      (error) => this.showErrorMessageWithTitle("Unable to add role registration", error),
    );

  }

}
